module.exports = __webpack_public_path__ + "static/media/gt.5764c1cc.svg";